module.exports = __webpack_public_path__ + "static/media/move.ba8d08ff.svg";